import { useDispatch, useSelector } from "react-redux";
import {
  syncPatchImages as alcoholSyncPatchImages,
  syncProperties as alcoholSyncProperties,
  syncSetData as alcoholSyncSetData,
  calculatePermille,
} from "./slices/alcoholSlice";
import {
  User,
  syncPatchImages as userSyncPatchImages,
  syncProperties as userSyncProperties,
  syncSetData as userSyncSetData,
} from "./slices/userSlice";
import {
  syncPatchImages as locationSyncPatchImages,
  syncProperties as locationSyncProperties,
  syncSetData as locationSyncSetData,
} from "./slices/locationSlice";
import {
  syncPatchImages as ownItemsSyncPatchImages,
  syncProperties as ownItemsSyncProperties,
  syncSetData as ownItemsSyncSetData,
} from "./slices/ownItems";
import { useSyncRedux } from "./sync";
import { useEffect } from "react";
import { setNotSyncing } from "./slices/syncSlice";

export const useSyncReduxAll = () => {
  const user: User = useSelector((state: any) => state.user);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setNotSyncing({ property: "user-settings" }));
    dispatch(setNotSyncing({ property: "alcohol-data" }));
    dispatch(setNotSyncing({ property: "own-items" }));
    dispatch(setNotSyncing({ property: "user-location" }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useSyncRedux({
    property: "user-settings",
    selector: (state: any) => state.user,
    syncProperties: userSyncProperties,
    setDataReducer: userSyncSetData,
    patchImagesReducer: userSyncPatchImages,
  });

  useSyncRedux({
    property: "alcohol-data",
    selector: (state: any) => state.alcohol,
    syncProperties: alcoholSyncProperties,
    setDataReducer: alcoholSyncSetData,
    patchImagesReducer: alcoholSyncPatchImages,
    afterSync: () => {
      dispatch(calculatePermille({ user }));
    },
  });

  useSyncRedux({
    property: "user-location",
    selector: (state: any) => state.location,
    syncProperties: locationSyncProperties,
    setDataReducer: locationSyncSetData,
    patchImagesReducer: locationSyncPatchImages,
  });

  useSyncRedux({
    property: "own-items",
    selector: (state: any) => state.ownItems,
    syncProperties: ownItemsSyncProperties,
    setDataReducer: ownItemsSyncSetData,
    patchImagesReducer: ownItemsSyncPatchImages,
  });
};
